module.exports = __webpack_public_path__ + "media/components/Hero/down-arrow-a40846ed2d1e8dd923947810b395b28b.svg";